export const APP_STORE = "reimbursement";

export const ENV_PROD_MODE = "production";

export const API_METHOD_GET = "GET";
export const API_METHOD_POST = "POST";
export const API_METHOD_PUT = "PUT";

export const USER_EXCEL_CONFIG_NAME = "invixUserExcelConfig";
export const USER_EXCEL_MASTER_COLS = "invixExcelColumns";

export const ENTITY_STATUS = {
  active: "active",
  inactive: "inactive",
  completed: "completed",
  deleted: "deleted",
  processing: "processing",
  failed: "failed",
  draft: "draft",
  approved: "approved",
  rejected: "rejected",
  viewed: "viewed",
};

export const PERMISSION_TYPES = {
  menuitem: "menuitem",
  parent: "parent",
};

export const googleLoginEnabled = "google-login";
export const newUserEnabled = "new-user";
export const approveRejectDoc = "approve-reject";
export const multiDocument = "multi-document";
export const projectCreateNeeded = "project-create-needed-comparator";
export const adminMfaEnabled = "admin-mfa";

export const systemAdmin = "system_admin";
export const dischargeSummary = "DISCHARGE SUMMARY";
export const dischargeSummaryINK = "discharge-summary-ink";
export const drawerWidth = 300;
